export default window.APP_CONF = {
    API_URL : "https://admin.farmacia.ua"
};

